__turbopack_context__.v({
  "author": "WClientTestimonialsCards-module__2uQZOa__author",
  "authorName": "WClientTestimonialsCards-module__2uQZOa__authorName",
  "authorSector": "WClientTestimonialsCards-module__2uQZOa__authorSector",
  "card": "WClientTestimonialsCards-module__2uQZOa__card",
  "controls": "WClientTestimonialsCards-module__2uQZOa__controls",
  "eyebrow": "WClientTestimonialsCards-module__2uQZOa__eyebrow",
  "header": "WClientTestimonialsCards-module__2uQZOa__header",
  "headerText": "WClientTestimonialsCards-module__2uQZOa__headerText",
  "heading": "WClientTestimonialsCards-module__2uQZOa__heading",
  "lead": "WClientTestimonialsCards-module__2uQZOa__lead",
  "nextBtn": "WClientTestimonialsCards-module__2uQZOa__nextBtn",
  "pagination": "WClientTestimonialsCards-module__2uQZOa__pagination",
  "prevBtn": "WClientTestimonialsCards-module__2uQZOa__prevBtn",
  "quoteIcon": "WClientTestimonialsCards-module__2uQZOa__quoteIcon",
  "root": "WClientTestimonialsCards-module__2uQZOa__root",
  "separator": "WClientTestimonialsCards-module__2uQZOa__separator",
  "slide": "WClientTestimonialsCards-module__2uQZOa__slide",
  "swiper": "WClientTestimonialsCards-module__2uQZOa__swiper",
  "testimonial": "WClientTestimonialsCards-module__2uQZOa__testimonial",
});
